export default __webpack_public_path__ + "static/media/expiryclock.9d254b59.svg";